import { render } from "./NotebookSnapshotIndicator.vue?vue&type=template&id=b1b3c7c4"
import script from "./NotebookSnapshotIndicator.vue?vue&type=script&lang=js"
export * from "./NotebookSnapshotIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__